export default function normalize(value) {
  if (typeof value !== 'string') {
    return value;
  }

  return value.replace(/[\D]+/, '');
}
